export const MONTHLY_TYPES = [
    { value: "EXPENSE", label: "Gasto" },
    { value: "INCOME", label: "Ingreso" },
];

export const MONTHLY_STATUS = [
    { value: "PAID", label: "Pagado / cobrado" },
    { value: "PENDING", label: "Pendiente" },
    { value: "CANCELLED", label: "Cancelado" },
];

export const MONTHLY_FIXED = [
    { value: "FIXED", label: "Fijo" },
    { value: "VARIABLE", label: "Variable" },
];

export const MONTHLY_FREQUENCIES = [
    { value: "MONTHLY", label: "Mensual" },
    { value: "BIMONTHLY", label: "Cada 2 meses" },
    { value: "QUARTERLY", label: "Trimestral" },
    { value: "SEMIANNUAL", label: "Semestral" },
    { value: "ANNUAL", label: "Anual" },
];

export const MONTHLY_CURRENCIES = [
    { value: "ARS", label: "ARS · Peso argentino" },
    { value: "USD", label: "USD · Dólar estadounidense" },
    { value: "EUR", label: "EUR · Euro" },
    { value: "BRL", label: "BRL · Real brasileño" },
    { value: "USDT", label: "USDT · Tether" },
];

export const MONTHLY_CATEGORIES = [
    { value: "Sueldo", label: "Sueldo" },
    { value: "Freelance", label: "Freelance / trabajos" },
    { value: "Ventas", label: "Ventas" },
    { value: "Otros ingresos", label: "Otros ingresos" },
    { value: "Alquiler", label: "Alquiler" },
    { value: "Expensas", label: "Expensas" },
    { value: "Electricidad", label: "Electricidad" },
    { value: "Gas", label: "Gas" },
    { value: "Agua", label: "Agua" },
    { value: "Internet", label: "Internet" },
    { value: "Celular", label: "Celular" },
    { value: "Streaming", label: "Streaming" },
    { value: "Software", label: "Software / servicios online" },
    { value: "Supermercado", label: "Supermercado" },
    { value: "Comida", label: "Comida" },
    { value: "Delivery", label: "Delivery" },
    { value: "Transporte", label: "Transporte" },
    { value: "Combustible", label: "Combustible" },
    { value: "Salud", label: "Salud" },
    { value: "Farmacia", label: "Farmacia" },
    { value: "Educación", label: "Educación" },
    { value: "Mascotas", label: "Mascotas" },
    { value: "Impuestos", label: "Impuestos" },
    { value: "Tarjetas", label: "Tarjetas" },
    { value: "Seguros", label: "Seguros" },
    { value: "Hogar", label: "Hogar" },
    { value: "Ropa", label: "Ropa" },
    { value: "Ocio", label: "Ocio" },
    { value: "Regalos", label: "Regalos" },
    { value: "Viajes", label: "Viajes" },
    { value: "Deudas", label: "Deudas / préstamos" },
    { value: "Ahorro / inversión", label: "Ahorro / inversión" },
    { value: "Otros", label: "Otros" },
];

export const MONTHLY_MONTHS = [
    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
].map((label, index) => ({ value: String(index + 1), label }));

const EVERY_MONTHS = { MONTHLY: 1, BIMONTHLY: 2, QUARTERLY: 3, SEMIANNUAL: 6, ANNUAL: 12 };

export const onMonthlyMoney = (value, currency = "ARS") => {
    const amount = Number(value || 0);
    try {
        return new Intl.NumberFormat("es-AR", { style: "currency", currency, maximumFractionDigits: 2 }).format(amount);
    } catch {
        return `${currency} ${amount.toLocaleString("es-AR", { maximumFractionDigits: 2 })}`;
    }
};

export const onMonthlyDate = (value, withTime = false) => {
    if (!value) return "-";
    const date = value instanceof Date ? value : new Date(String(value).length === 10 ? `${value}T12:00:00` : value);
    if (Number.isNaN(date.getTime())) return "-";
    return date.toLocaleDateString("es-AR", withTime ? { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" } : { day: "2-digit", month: "2-digit", year: "numeric" });
};

export const onMonthlyOption = (options, value) => options.find((item) => item.value === value)?.label || value || "-";
export const onMonthlyPeriodKey = (year, month) => `${year}-${String(month).padStart(2, "0")}`;

export const onRecurringApplies = (rule, year, month) => {
    if (!rule?.startDate) return false;
    const start = new Date(`${String(rule.startDate).slice(0, 10)}T12:00:00`);
    if (Number.isNaN(start.getTime())) return false;
    const diff = (Number(year) - start.getFullYear()) * 12 + (Number(month) - (start.getMonth() + 1));
    if (diff < 0) return false;
    if (rule.endDate) {
        const end = new Date(`${String(rule.endDate).slice(0, 10)}T12:00:00`);
        const target = Number(year) * 12 + Number(month);
        const endValue = end.getFullYear() * 12 + end.getMonth() + 1;
        if (target > endValue) return false;
    }
    return diff % (EVERY_MONTHS[rule.frequency] || 1) === 0;
};

export const onMonthlyDueDate = (rule, year, month) => {
    const last = new Date(Number(year), Number(month), 0).getDate();
    const day = Math.min(Math.max(1, Number(rule?.dueDay || 1)), last);
    return new Date(Number(year), Number(month) - 1, day, 12, 0, 0);
};

export const onMonthlyIsOverdue = (entry) => {
    if (!entry || entry.status !== "PENDING" || !entry.dueDate) return false;
    const due = new Date(`${String(entry.dueDate).slice(0, 10)}T23:59:59`);
    return due.getTime() < Date.now();
};
